import { FunctionsHttpError } from '@supabase/supabase-js'

export interface EdgeErrorInfo {
  code: string
  /** The Edge Function's own `error` string, when it sent one. */
  message: string | null
}

/**
 * `supabase.functions.invoke` rejects with a FunctionsHttpError whose `.message`
 * is always the fixed string "Edge Function returned a non-2xx status code" — the
 * typed `{ error, code }` body lives on `.context`, an unread Response. Parsing
 * `.message` therefore never yields a code, which is how every Edge Function
 * failure used to collapse into a single generic message.
 */
export async function extractEdgeError(err: unknown): Promise<EdgeErrorInfo> {
  if (err instanceof FunctionsHttpError) {
    try {
      const body = (await err.context.json()) as { code?: string; error?: string }
      return { code: body.code ?? 'INTERNAL_ERROR', message: body.error ?? null }
    } catch {
      // Non-JSON body (gateway error page, empty 502) — fall through to generic.
    }
  }
  return { code: 'INTERNAL_ERROR', message: null }
}
